var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-header',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHeader),expression:"showHeader"}]}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('main-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFooter),expression:"showFooter"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d989be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 